


import React from 'react'
import './HeroSection.css'
import {Container, Row, Col} from 'reactstrap'
import { Link } from 'react-router-dom'
import HeroImg from '../../assets/images/hero.jpg'

const HeroSection = () => {
  return (
    <section className='hero_section'>
    <Container>
        <Row>
            <Col lg='6' md='6'>
            <div className='hero_content'>
            <h2> Discover rare digital art and collect, <span> Sell Extraordinary
            </span> NFTs</h2>
            <p> Es un hecho establecido hace demasiado tiempo que un lector se
             distraerá con el contenido del texto de un sitio mientras que mira su diseño.
            </p>

           <div className='hero_btns d-flex align-items-center gap-4'>
           <button className='explore_btn d-flex align-items-center gap-2'>
            <i class="ri-rocket-line"></i> 
            <Link to='/market'> Explore</Link></button>
            <button className='create_btn d-flex align-items-center gap-2'> 
            <i class="ri-ball-pen-line"></i> 
            <Link to='/create'> Create</Link></button>
           </div>
            </div>
            </Col>

            <Col lg='6' md='6'>
            <div className='hero_img'>
                <img src={HeroImg} alt='' className='w-100' />
            </div>

            </Col>


        </Row>
    </Container>
    </section>
  )
}

export default HeroSection